/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { customLogin } from '../fn/login/custom-login';
import { CustomLogin$Params } from '../fn/login/custom-login';
import { customLoginAuthentification } from '../fn/login/custom-login-authentification';
import { CustomLoginAuthentification$Params } from '../fn/login/custom-login-authentification';
import { UserProfileSummary } from '../models/user-profile-summary';


/**
 * All about the login
 */
@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customLogin()` */
  static readonly CustomLoginPath = '/custom/login';

  /**
   * Login user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  customLogin$Response(params?: CustomLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileSummary>> {
    return customLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * Login user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customLogin(params?: CustomLogin$Params, context?: HttpContext): Observable<UserProfileSummary> {
    return this.customLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileSummary>): UserProfileSummary => r.body)
    );
  }

  /** Path part for operation `customLoginAuthentification()` */
  static readonly CustomLoginAuthentificationPath = '/custom/login/auth';

  /**
   * Authentification login user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customLoginAuthentification()` instead.
   *
   * This method doesn't expect any request body.
   */
  customLoginAuthentification$Response(params?: CustomLoginAuthentification$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileSummary>> {
    return customLoginAuthentification(this.http, this.rootUrl, params, context);
  }

  /**
   * Authentification login user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customLoginAuthentification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customLoginAuthentification(params?: CustomLoginAuthentification$Params, context?: HttpContext): Observable<UserProfileSummary> {
    return this.customLoginAuthentification$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileSummary>): UserProfileSummary => r.body)
    );
  }

}
